export default "__VITE_ASSET__ee421ex0__"